const CommentIcon = () => {
  return (
    <svg
      width="22.5"
      height="22.5"
      viewBox="0 0 35 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.375 33.875H33.25C28.6259 33.8748 24.1569 32.2077 20.6623 29.1794L19.4792 28.154C18.8229 28.2178 18.1593 28.25 17.5 28.25C13.0333 28.25 8.82449 26.8134 5.64897 24.205C2.40918 21.5438 0.625 17.9861 0.625 14.1875C0.625 10.3889 2.40918 6.8312 5.64897 4.17001C8.82449 1.56155 13.0333 0.125 17.5 0.125C21.9667 0.125 26.1755 1.56155 29.351 4.17001C32.5908 6.8312 34.375 10.3889 34.375 14.1875C34.3734 16.2068 33.8638 18.1931 32.893 19.9637C32.0504 21.5058 30.9282 22.8777 29.5838 24.0093C30.5885 26.5642 32.1071 28.8855 34.0454 30.8296L34.375 31.159V33.875ZM20.2039 25.8047L22.1359 27.4791C24.8006 29.7883 28.1183 31.2102 31.6281 31.5474C29.6916 29.3827 28.196 26.861 27.2253 24.1236V24.1236L26.9163 23.2473L27.5638 22.7503C30.5052 20.493 32.125 17.452 32.125 14.1875C32.125 7.67403 25.5642 2.375 17.5 2.375C9.43579 2.375 2.875 7.67403 2.875 14.1875C2.875 20.701 9.43579 26 17.5 26C18.238 25.9999 18.9753 25.955 19.7078 25.8655L20.2039 25.8047Z"
        fill="#FF8A33"
      />
    </svg>
  );
};

export default CommentIcon;
